import React, {useEffect} from 'react';
import { Field } from 'react-final-form';
import RadioButton from './RadioBig';
import Grid from "@material-ui/core/Grid";
import { Trans } from "../utils/i18n";

const AppointmenttypeSelect = React.memo(function ({ requesttypes, requesttype, form }) {

        useEffect(() => {
            if(requesttypes.length === 1) {
                form.change('appointmentGroup', requesttypes[0].key);
                if(requesttypes[0].type === 'appointment') {
                    form.change('partner_id', 'none');
                }
            }
        }, []);

        if(requesttypes.length === 1) {
            return <></>;
        }

        return (
            <div>
                <div>
                    <h3>
                        <Trans i18nKey="appointment.form.appointmentGroup">Appointment type</Trans>
                    </h3>
                    <p>
                        <Trans i18nKey="appointment.form.appointmentGroup.description">Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.</Trans>
                    </p>
                </div>
                <Grid container spacing={3}>
                    {
                        requesttypes
                            .map((item) =>
                                <Grid item xs={12} sm={4} key={item.id}>
                                    <Field
                                        name={'appointmentGroup'}
                                        type={'radio'}
                                        value={item.key}
                                        component={RadioButton}
                                        validate={value => (value ? undefined : <Trans i18nKey="appointmentTypeSelect.required">Required</Trans>)}
                                        field={{
                                            titel: item.name,
                                            description: item.description,
                                            price: item.price,
                                        }}
                                    />
                                </Grid>,
                            )
                    }
                </Grid>
            </div>
        );
    },
    function areEqual(prevProps, nextProps) {
        return JSON.stringify(prevProps) === JSON.stringify(nextProps);
    });

export default AppointmenttypeSelect;
